/** Formatte un nombre en euros français : 12 345 € */
export function fmtEur(n: number, decimals = 0): string {
  return n.toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

/** Formatte un nombre court : 12,3 k€ / 1,2 M€ */
export function fmtK(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace('.', ',')} M€`;
  if (n >= 1_000)     return `${(n / 1_000).toFixed(1).replace('.', ',')} k€`;
  return `${Math.round(n)} €`;
}

/** Formatte une date ISO en "29 avril 2026". */
export function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString('fr-FR', {
    day: 'numeric', month: 'long', year: 'numeric'
  });
}

/** Date du jour au format ISO "YYYY-MM-DD". */
export function todayIso(): string {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

/** Formatte un entier en notation française : 12 345 (sans euro). */
export function fmtN(n: number): string {
  return Math.round(n).toLocaleString('fr-FR').replace(/\u202F/g, '\u00A0');
}
